// Following https://edcarroll.github.io/ng2-semantic-ui/#/components/modal

import { Component } from '@angular/core'
import { SuiModal, ComponentModalConfig, ModalSize } from 'ng2-semantic-ui'

interface IConfirmModalContext {
  title: string
  question: string
}

@Component({
  selector: 'ld-confirm-modal',
  template: require('./confirm-modal.component.html'),
  styles: [require('./confirm-modal.component.css')]
})
export class ConfirmModalComponent {
  constructor (public modal: SuiModal<IConfirmModalContext, void, void>) {}
}

export class ConfirmModal extends ComponentModalConfig<IConfirmModalContext, void, void> {
  constructor (title: string, question: string) {
    super(ConfirmModalComponent, { title, question })

    this.isClosable = false
    this.transitionDuration = 200
    this.size = ModalSize.Small
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/confirm-modal/confirm-modal.component.ts